'use client';

import { c as _c } from "react/compiler-runtime";
import { createLogger } from '@svs/nova-core/log';
import { updateCouponBoard, updateCouponOutcome } from '@svs/nova-poolbetting/core/frameworks/actions/coupon';
import { useCouponId, useCouponUserOutcomes } from '@svs/nova-poolbetting/core/frameworks/nextjs/coupon';
import { useCurrentDrawInfo } from '@svs/nova-poolbetting/core/frameworks/nextjs/draw';
import { useGetQuickPick } from '@svs/nova-poolbetting/core/frameworks/nextjs/quickpick';
import type { CouponIndex } from '@svs/nova-poolbetting/schema/coupon';
import { PixSrowCouponButton } from '@svs/nova-poolbetting/ui/Coupon';
import { type ReactNode, useRef } from 'react';
const logger = createLogger('coupon-row-quick-pick-button');

/**
 * Component that renders the Pix button for a coupon row.
 *
 * @param root0 props for the component
 * @param root0.couponIndex index of the coupon to render
 * @returns component that renders the Pix button for a coupon row
 */
export function CouponPixButtonClientContainer(t0) {
  const $ = _c(14);
  const {
    couponIndex
  } = t0;
  const [couponId] = useCouponId();
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex) {
    t1 = {
      couponId,
      couponIndex,
      boardIndex: 0
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const userOutcomesPayload = useCouponUserOutcomes(t1);
  let t2;
  if ($[3] !== userOutcomesPayload) {
    t2 = userOutcomesPayload.some(_temp);
    $[3] = userOutcomesPayload;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const hasUserOutcomes = t2;
  const {
    mutate: mutateQuickPick
  } = useGetQuickPick();
  const currentDrawInfo = useCurrentDrawInfo();
  const currentDrawNumber = useRef(currentDrawInfo.drawNumber);
  let t3;
  if ($[5] !== couponId || $[6] !== couponIndex || $[7] !== hasUserOutcomes || $[8] !== mutateQuickPick || $[9] !== userOutcomesPayload) {
    t3 = () => {
      (async () => {
        if (!currentDrawNumber.current) {
          return;
        }
        mutateQuickPick({
          product: "Powerplay",
          payload: hasUserOutcomes ? [userOutcomesPayload] : {},
          options: {
            type: {
              systemType: "SROW",
              rowCount: 1
            },
            flavour: "Safe1X2",
            drawNumber: currentDrawNumber.current
          }
        }, {
          onSuccess: data => {
            const [outcomes] = data;
            if (outcomes) {
              updateCouponOutcome(outcomes, {
                couponId,
                couponIndex,
                boardIndex: 0
              }, "keep").catch(_temp2);
            }
          },
          onError: _temp3
        });
        await updateCouponBoard({
          quickPickSize: 1
        }, {
          couponId,
          couponIndex,
          boardIndex: 0
        });
      })();
    };
    $[5] = couponId;
    $[6] = couponIndex;
    $[7] = hasUserOutcomes;
    $[8] = mutateQuickPick;
    $[9] = userOutcomesPayload;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const getQuickPick = t3;
  let t4;
  if ($[11] !== couponIndex || $[12] !== getQuickPick) {
    t4 = <PixSrowCouponButton couponIndex={couponIndex} handleOnClick={getQuickPick} />;
    $[11] = couponIndex;
    $[12] = getQuickPick;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp3(err) {
  const errorMessage_0 = err instanceof Error ? err.message : "Unknown error";
  logger.warn(`QuickPick failed msg ${errorMessage_0}`);
}
function _temp2(error) {
  const errorMessage = error instanceof Error ? error.message : "Unknown error";
  logger.warn(`Updating coupon outcomes failed msg ${errorMessage}`);
}
function _temp(event) {
  return event[0]?.[0] !== undefined;
}